module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/gO1js3/tc-custom/9781649795557.jpg?1705540719146",
      "alt": "This image is the cover for the book Bernie and Babs vs the Virus"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bernie and Babs vs the Virus\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("Journey with Bernie and Babs on a self-healing visualization. Bang those baddies on the head and send them to waste disposal.")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("Bernie and Babs take on the virus with magic hammers and some serious hi-tech know-how. Adventure awaits in this charming and useful book that gives you a visual that can be used to imagine your own healing. See you in the cranial control center for bug and bot deployment. ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Grandma Ness\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("I healed myself the way I show in the book (Lupus). I taught my children and they do the same. My grandchildren are learning now. ")]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_vm._v("Twenty-two years ago I had the idea to write the words, did the first rendition of Bernie and Babs, and put down a storyboard. Nine months ago while transferring my art cabinet to the new studio (I am a painter by trade) that work fell out in the yard. My new adopted dog grabbed it and brought it inside and put it on my lap. Since then every time I let it fall aside, a sketch or painting falls off a table or wall to the ground. I have no credentials to validate my knowledge or the vision of this book. I do have the unwavering knowing that it will help heal millions if not billions. Our minds are miracles we have yet to tap to the fullest. This book is a step toward that. ")]), _c('p', {
    staticStyle: {
      "margin": "0cm 0cm 0.0001pt",
      "font-size": "15px",
      "font-family": "Calibri, sans-serif",
      "text-align": "right",
      "background": "white"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "16px",
      "font-family": "\"Arial\",sans-serif",
      "color": "black"
    }
  }, [_vm._v("– Grandma Ness")])]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p', {
    staticStyle: {
      "margin": "0cm",
      "font-size": "15px",
      "font-family": "\"Grotesque Light\",sans-serif"
    }
  }, [_c('br')]), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0